module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Medium.ttf
// module id = 274
// module chunks = 0